import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import HeroSection from "./sections/HeroSection";
import AboutSection from "./sections/AboutSection";
import FeaturesSection from "./sections/FeaturesSection";
import HowItWorksSection from "./sections/HowItWorksSection";
import UseCasesSection from "./sections/UseCasesSection";
import CtaSection from "./sections/CtaSection";
import styles from "./LandingPage.module.css";

const HEADER_OFFSET = 76;

const LandingPage = () => {
  const location = useLocation();

  useEffect(() => {
    const id = 'v4d-gfonts';
    if (!document.getElementById(id)) {
      const link = document.createElement('link');
      link.id = id;
      link.rel = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap';
      document.head.appendChild(link);
    }
  }, []);

  useEffect(() => {
    const hash = location.hash?.replace("#", "");
    if (hash) {
      const el = document.getElementById(hash);
      if (el) {
        window.scrollTo({
          top: el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET,
          behavior: "smooth"
        });
      }
    }
  }, [location.pathname, location.hash]);

  return (
    <main className={styles.landingMain}>
      <HeroSection />
      <HowItWorksSection />
      <AboutSection />
      <FeaturesSection />
      <UseCasesSection />
      <CtaSection />
    </main>
  );
};

export default LandingPage;

